<template>
    <div
      id="app"
      :class="{ 'has-mouse': hasMouse }"
      @touchstart="hasMouse = false"
    >
      <Flipbook
        class="pawiwahan"
        :pages="pages"
        :pagesHiRes="pagesHiRes"
        :startPage="pageNum"
        v-slot="flipbook"
        ref="flipbook"
        @flip-left-start="onFlipLeftStart"
        @flip-left-end="onFlipLeftEnd"
        @flip-right-start="onFlipRightStart"
        @flip-right-end="onFlipRightEnd"
        @zoom-start="onZoomStart"
        @zoom-end="onZoomEnd"
      >
        <div class="action-bar">
          <left-icon
            class="btn left"
            :class="{ disabled: !flipbook.canFlipLeft }"
            @click="flipbook.flipLeft"
          />
          <plus-icon
            class="btn plus"
            :class="{ disabled: !flipbook.canZoomIn }"
            @click="flipbook.zoomIn"
          />
          <span class="page-num">
            Acara Pawiwahan <span class="pengantin">Bara</span> 💍 <span class="pengantin">Emi</span>.
            <br/><strong>Senin, 20 April 2020</strong> | <strong>14.00 s.d. 18.00 WITA</strong> di lokasi <a href="https://goo.gl/maps/56KbkyCzKz8hHAXW8" target="_blank" title="Google Maps">
            <strong>Upacara.</strong>
          </a>📍
          <!-- Halaman {{ flipbook.page }} dari {{ flipbook.numPages }} -->
          </span>
          <minus-icon
            class="btn minus"
            :class="{ disabled: !flipbook.canZoomOut }"
            @click="flipbook.zoomOut"
          />
          <right-icon
            class="btn right"
            :class="{ disabled: !flipbook.canFlipRight }"
            @click="flipbook.flipRight"
          />
        </div>
      </Flipbook>
      <p class="berbahagia">
        Kami mengundang <span class="nama-undangan">{{ namaUndangan }}</span>✨
        <br/>Mohon Doa Restu agar pelaksanaan acara kami berjalan lancar 🙏
        <br/>(Mode <strong>Landspace</strong> untuk tampilan maksimal)
      </p>
    </div>
</template>

<script>
import 'vue-material-design-icons/styles.css'
import Flipbook from 'flipbook-vue'
import LeftIcon from 'vue-material-design-icons/ChevronLeftCircle'
import RightIcon from 'vue-material-design-icons/ChevronRightCircle'
import PlusIcon from 'vue-material-design-icons/PlusCircle'
import MinusIcon from 'vue-material-design-icons/MinusCircle'

export default {
  components: { Flipbook, LeftIcon, RightIcon, PlusIcon, MinusIcon },
  data() {
    return {
      pages: [],
      pagesHiRes: [],
      hasMouse: true,
      pageNum: null,
      namaUndangan: null,
    }
  },
  methods: {
    onFlipLeftStart: (page) => {
      // console.log('flip-left-start', page)
    },
    onFlipLeftEnd: (page) => {
      // console.log('flip-left-end', page)
      window.location.hash = '#' + page
    },
    onFlipRightStart: (page) => {
      // console.log('flip-right-start', page)
    },
    onFlipRightEnd: (page) => {
      // console.log('flip-right-end', page)
      window.location.hash = '#' + page
    },
    onZoomStart: (zoom) => {
      // console.log('zoom-start', zoom)
    },
    onZoomEnd: (zoom) => {
      // console.log('zoom-end', zoom)
    },
    setPageFromHash: function () {
      let n = parseInt(window.location.hash.slice(1), 10)
      if (isFinite(n)) {
        this.pageNum = n
      }
    },
    getQueryStringValue (key) {
      return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key)
              .replace(/[.+*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
    }
},
  mounted() {
    setTimeout(() => {
      window.scrollTo(0,5);
    },500)

    this.namaUndangan = this.getQueryStringValue("s") || 'Anda'

    window.addEventListener('hashchange', this.setPageFromHash)
    this.setPageFromHash()

    window.addEventListener('keydown', ev => {
      const {
        flipbook
      } = this.$refs;
      if (!flipbook) { return; }
      if ((ev.keyCode === 37) && flipbook.canFlipLeft) { flipbook.flipLeft(); }
      if ((ev.keyCode === 39) && flipbook.canFlipRight) { return flipbook.flipRight(); }
    })

    // Simulate asynchronous pages initialization
    return setTimeout((() => {
      this.pages = [
        null,
        'images/1.jpg',
        'images/2.jpg',
        'images/3.jpg',
        'images/4.jpg',
        'images/5.jpg',
        'images/6.jpg',
      ]
      return this.pagesHiRes = [
        null,
        'images-large/1.jpg',
        'images-large/2.jpg',
        'images-large/3.jpg',
        'images-large/4.jpg',
        'images-large/5.jpg',
        'images-large/6.jpg',
      ]
    }
    ), 1)
  }
}
</script>

<style>
  html, body {
    margin: 0;
    padding: 0;
    height: 100vh;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #333;
    color: #ccc;
    overflow: hidden;
  }

  a {
    color: inherit;
  }

  .action-bar {
    width: 100%;
    height: 30px;
    padding: 10px 0;
    margin-bottom: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .action-bar .btn {
    font-size: 30px;
    color: #999;
  }
  .action-bar .btn svg {
    bottom: 0;
  }
  .action-bar .btn:not(:first-child) {
    margin-left: 10px;
  }
  .has-mouse .action-bar .btn:hover {
    color: #ccc;
    filter: drop-shadow(1px 1px 5px #000);
    cursor: pointer;
  }
  .action-bar .btn:active {
    filter: none !important;
  }
  .action-bar .btn.disabled {
    color: #666;
    pointer-events: none;
  }
  .action-bar .page-num {
    text-align: center;
    font-size: .7rem;
    margin-left: 10px;
  }
  .pawiwahan {
    margin: 10px 0;
    width: 90vw;
    height: 85vh;
    display: flex;
    flex-direction: column;
  }
  .pawiwahan .viewport {
    width: 90vw;
    height: calc(85vh - 50px - 40px);
    order: 0;
  }
  .pawiwahan .bounding-box {
    box-shadow: 0 0 20px #000;
  }
  .nama-undangan, .pengantin {
    font-weight: bold;
    text-decoration: underline;
  }
  .berbahagia {
    text-align: center;
    font-size: .7rem;
    line-height: 20px;
    margin: 0;
  }
</style>

